<template>
  <div class="login-container">
    <div class="wrapper">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        auto-complete="on"
        label-position="right"
      >
        <h3 class="title">
          <span>学校端</span>
          身份认证登录
        </h3>
        <el-form-item prop="username" class="username_style">
          <!-- <span class="svg-container svg-container_login">
            <svg-icon icon-class="user" />
          </span> -->
          <img
            src="../../assets/username_icon.png"
            alt=""
            class="username_icon"
          />
          <el-input
            style="padding-left: 50px"
            v-model="loginForm.username"
            name="username"
            type="text"
            auto-complete="on"
            placeholder="账号"
          />
        </el-form-item>
        <el-form-item prop="password" class="password_style">
          <!-- <span class="svg-container">
            <svg-icon icon-class="password" />
          </span> -->
          <img
            src="../../assets/password_icon.png"
            alt=""
            class="password_icon"
          />
          <el-input
            style="padding-left: 50px"
            :type="pwdType"
            v-model="loginForm.password"
            name="password"
            auto-complete="on"
            placeholder="密码"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye" />
          </span>
        </el-form-item>

        <el-form-item style="margin-top: 50px">
          <el-button
            :loading="loading"
            type="primary"
            style="width: 100%"
            @click.native.prevent="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
        <el-row class="keep-login">
          <el-checkbox v-model="loginForm.keepLogin">保持登录</el-checkbox>
        </el-row>
        <!-- <div class="tips">
          <span style="margin-right:20px;">username: admin</span>
          <span> password: admin</span>
        </div> -->
      </el-form>
    </div>

    <img src="../../assets/login_top1.png" alt="" class="login_top1" />
    <img src="../../assets/login_top2.png" alt="" class="login_top2" />
    <img src="../../assets/login_bottom1.png" alt="" class="login_bottom1" />
  </div>
</template>

<script>
import { isvalidUsername } from "@/utils/validate";
import request from "@/utils/request";

export default {
  name: "Login",
  data() {
    const validateName = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error("账号不能为空"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
        keepLogin: false,
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateName },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePass },
        ],
      },
      loading: false,
      pwdType: "password",
    };
  },
  computed: {},
  methods: {
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("Login", this.loginForm)
            .then(() => {
              this.loading = false;
              this.$router.push({ path: "/" });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;

  background-image: url("../../assets/login_bg.png");
  background-repeat: no-repeat;
  // background-attachment: fixed;
  background-size: 100%;
  .wrapper {
    position: absolute;
    left: 0;
    right: 0;
    width: 520px;
    padding: 35px 35px 50px 35px;
    margin: 251px auto;

    width: 510px;
    // height: 491px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(20px);
  }
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 520px;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    color: $light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
    font-family: "Times New Roman", Times, serif;
    span {
      display: block;
      font-size: 36px;
      margin-bottom: 10px;
    }
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .keep-login {
    text-align: right;
    margin-top: -20px;
    padding: 10px 0;
  }
}
.username_style {
  color: #333333 !important;
  background: #ffffff !important;
}
.password_style {
  background: #ffffff !important;
}
.username_icon {
  position: absolute;
  top: 10px;
  left: 15px;
  width: 28px;
  height: 28px;
}
.password_icon {
  position: absolute;
  top: 10px;
  left: 15px;
  width: 28px;
  height: 28px;
}
.login-container .el-input input {
  color: #333333 !important;
}
</style>


<style rel="stylesheet/scss" lang="scss">
$bg: #2d3a4b;
$light_gray: #eee;

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
  .keep-login .el-checkbox {
    color: #fff;
    opacity: 0.8;
  }
}
.login_top1 {
  position: absolute;
  top: 60px;
  left: 50px;
  width: 651px;
  height: 38px;
}
.login_top2 {
  position: absolute;
  top: 137px;
  left: 50px;
  width: 275px;
  height: 80px;
}
.login_bottom1 {
  position: absolute;
  bottom: 49px;
  left: 629px;
  width: 658px;
  height: 82px;
}
</style>

<style lang="scss">
.login-container .el-input input {
  color: #333333;
}
</style>

